module.exports = __webpack_public_path__ + "media/images/mail_template/tw-eb69ded001b52128d3e4fec7457774db.png";